import {
  Button,
} from "react-bootstrap";
import {
  FaBars,
  FaRegBell,
  FaAngleDown
} from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "../../services/baseService";
import { getSearchResults, resetSearch } from "../../slices/commonReducer";
import { useSelector, useDispatch } from "react-redux";
import { setScreenView, setSearch, setSelectedMonthYear } from "../../slices/commonReducer";
import { clearNotification, getNotifications, clearFcmNotification } from "../../slices/notificationReducer";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { FaMagnifyingGlass } from "react-icons/fa6";
import ResetPasswordOffcanvas from "./ResetPasswordModal";
import { Dropdown } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import useSidebar from "../../hooks/useSidebar";
import { truncateText } from "../../utils";
import { toastService } from "../../utils/toastService";
function Header(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSidebarCollapsed, toggle } = useSidebar();
  const { notification, notificationList, isNotificationRoute, notificationUrl, newNotificationFound, fcmNotificationReceived } = useSelector((state) => state.notification);
  const { title, hideDatepicker, headerType, showSearchIcon = false } = props;
  const { name, email, role } = useSelector((state) => state.common);
  const [headerSearchText, setHeaderSearchText] = useState("");
  const [headerSearchType, setHeaderSearchType] = useState(1);
  const [selectedFilterLabel, setSelectedFilterLabel] = useState("Client Name");
  const { gridView, searchList, enableSearch } = useSelector(
    (state) => state.common
  );
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [current_page, setCurrentPage] = useState(1);
  const [time, setTime] = useState(getCurrentTime());
  const location = useLocation();

  const handleSignOut = () => {
    signOut().then((response) => {
      navigate("/login");
    });
  };

  const handleResetPasswordModalClose = async () => {
    setShowResetPasswordModal(false);
  }

  const handleNotificationIconClick = async () => {
    dispatch(clearFcmNotification());
    navigate('/notifications');
  }
  useEffect(() => {
    if (isNotificationRoute) {
      navigate(notificationUrl);
    }

  }, [isNotificationRoute]);

  useEffect(() => {
    if (newNotificationFound) {
      toastService.success("New notification received!")
      dispatch(getNotifications({ page: current_page }));
    }
    dispatch(clearNotification());
  }, [newNotificationFound]);

  function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getCurrentTime());
    }, 1000); // update every second

    return () => clearInterval(timer); // cleanup on unmount
  }, []);

  const g = (id) => {
    const el = document.getElementById(id);
    if (el) el.checked = true;
  };

  useEffect(() => {
    const initialSidebarSize = document.body.getAttribute("data-sidebar-size");

    // Equivalent of window.onload logic
    if (window.innerWidth >= 1024 && window.innerWidth <= 1366) {
      document.body.setAttribute("data-sidebar-size", "lg");
      g("sidebar-size-small");
    }

    const handleSidebarToggle = (e) => {
      e.preventDefault();
      document.body.classList.toggle("sidebar-enable");

      if (window.innerWidth >= 992) {
        const currentSize = document.body.getAttribute("data-sidebar-size");

        if (!initialSidebarSize) {
          if (!currentSize || currentSize === "lg") {
            document.body.setAttribute("data-sidebar-size", "sm");
          } else {
            document.body.setAttribute("data-sidebar-size", "lg");
          }
        } else if (initialSidebarSize === "md") {
          if (currentSize === "md") {
            document.body.setAttribute("data-sidebar-size", "sm");
          } else {
            document.body.setAttribute("data-sidebar-size", "md");
          }
        } else {
          if (currentSize === "sm") {
            document.body.setAttribute("data-sidebar-size", "lg");
          } else {
            document.body.setAttribute("data-sidebar-size", "sm");
          }
        }
      }
    };

    const buttons = document.getElementsByClassName("vertical-menu-btn");
    Array.from(buttons).forEach((btn) =>
      btn.addEventListener("click", handleSidebarToggle)
    );

    // Cleanup
    return () => {
      Array.from(buttons).forEach((btn) =>
        btn.removeEventListener("click", handleSidebarToggle)
      );
    };
  }, []);
  /* Sidebar Toggle */

  const handleSearchInputChange = (e) => {
    setHeaderSearchText(e.target.value);
  };

  // Handle filter dropdown change
  const handleFilterChange = (filterType, filterLabel) => {
    setHeaderSearchType(filterType);
    setSelectedFilterLabel(filterLabel);
  };

  // Handle search submission
  const handleSearch = (e) => {
    e.preventDefault();

    // Check if search text is not empty
    if (headerSearchText.trim() === "") {
      return;
    }

    // Navigate to search page with query parameters
    navigate(`/search?q=${encodeURIComponent(headerSearchText)}&type=${headerSearchType}`);

    // Optional: Clear the header search after navigation
    // setHeaderSearchText("");
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && headerSearchText.trim() !== '') {
      handleSearch(e);
    }
  };


  return (
    <header id="page-topbar" className="!z-50">
      <div className="navbar-header">
        <div className="d-flex">
          <div className="navbar-brand-box p-0">
            <Link to="/" className="logo logo-light">
              <span className="logo-sm">
                <img
                  src="/assets/images/logo-dark.png"
                  alt="logo"
                  className="h-10 inline"
                  height="40"
                />
              </span>
              <span className="logo-lg">
                <img
                  src="/assets/images/logo-dark.png"
                  alt="logo"
                  className="h-10 inline"
                  height="40"
                />
              </span>
            </Link>
          </div>

          <button type="button" className="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle();
          }}>
            <FaBars />
          </button>

          {!location.pathname.includes('search') && (
            <div className="search-box pf-search-box d-flex align-items-center flex-grow-1">
              <form className="p-2 flex-grow-1" onSubmit={handleSearch}>
                <div className="search-box position-relative">
                  <input
                    type="text"
                    className="form-control rounded bg-light border-0 responsive-search-input p-3"
                    placeholder="Find Clients, GST, Invoice..."
                    value={headerSearchText}
                    style={{ width: '350px' }}
                    onChange={handleSearchInputChange}
                    onKeyPress={handleKeyPress}
                  />

                  <button
                    type="submit"
                    className="btn btn-primary position-absolute top-50 translate-middle-y border-0 rounded-pill"
                    style={{
                      right: '8px',
                      height: '26px',
                      width: '32px',
                      padding: '0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    title="Click to search"
                    disabled={headerSearchText.trim() === ""}
                  >
                    <FaMagnifyingGlass style={{ fontSize: '13px' }} />
                  </button>
                </div>
              </form>

              <Dropdown>
                <Dropdown.Toggle
                  variant="transparent"
                  className="bg-transparent border-0 d-flex align-items-center h-100 text-muted shadow-none"
                  style={{ minWidth: '120px', borderRadius: '0' }}
                  id="dropdown-basic"
                >
                  <span className="small">{selectedFilterLabel}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="border-0">
                  <Dropdown.Item
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => handleFilterChange(1, 'Client Name')}
                  >
                    <span>Client Name</span>
                  </Dropdown.Item>

                  <Dropdown.Item
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => handleFilterChange(2, 'GST Number')}
                  >
                    <span>GST Number</span>
                  </Dropdown.Item>

                  <Dropdown.Item
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => handleFilterChange(3, 'Invoice Number')}
                  >
                    <span>Invoice Number</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          {/* <p className="pf-time d-none d-lg-block mb-0 ms-3">{time}</p> */}
        </div>

        <div className="d-flex align-items-center">
          <div className="dropdown d-inline-block">
            <button
              className="btn header-item noti-icon"
              id="page-header-notifications-dropdown"
              data-bs-toggle="dropdown"
              onClick={handleNotificationIconClick}
            >
              <FaRegBell className="w-5 h-5" />
              <span className={fcmNotificationReceived && `noti-dot bg-danger`}></span>
            </button>
          </div>
          {/* <a href="#" className="pf-btn btn-primary pf-nav-btn">Invite</a> */}
          <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item user text-start d-flex align-items-center"
              id="page-header-user-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                className="rounded-circle header-profile-user"
                src="/assets/images/avatar-10.jpg"
                alt="Header Avatar"
              />
              <span className="ms-2 d-none d-sm-block user-item-desc">
                <span className="user-name">{email}</span>
              </span>
              <FaAngleDown />
            </button>

            <div
              className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3 p-0"
              style={{ minWidth: '260px' }}
              aria-labelledby="page-header-user-dropdown"
            >
              {/* Header */}
              <div className=" px-4 py-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 text-dark fw-bold">Profile</h6>
                  <i className="ri-close-fill text-muted cursor-pointer"></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <div className="text-center">
                  {/* Avatar */}
                  <div
                    className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center fw-bold mb-3"
                    style={{ width: '48px', height: '48px', fontSize: '18px' }}
                  >
                    {!!name ? name[0].toUpperCase() : ""}
                  </div>

                  {/* Details */}
                  <h6 className="mb-1">
                    <Link
                      to="/manage-profile"
                      className="text-decoration-none text-dark fw-bold"
                    >
                      {truncateText(name ? name : "", 30)}
                    </Link>
                  </h6>
                  <p className="text-muted small mb-1">{role}</p>

                  {/* Buttons */}
                  <div className="d-grid gap-2">
                    <Button
                      variant="light"
                      size="sm"
                      className="!font-semibold"
                      onClick={() => setShowResetPasswordModal(true)}
                    >
                      Update Password
                    </Button>

                    <Button
                      onClick={handleSignOut}
                      variant="primary"
                      size="sm"
                      className="!font-semibold"
                    >
                      Sign Out
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <ResetPasswordOffcanvas showModal={showResetPasswordModal} handleModalClose={handleResetPasswordModalClose} />
    </header>
  );
}

export default Header;
